/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../helpers/LanguageHelper'
import { ReactCropper } from '../widgets'

type Props = {
  functionSubmit?: any
  isSubmitContinue?: boolean
}

const ImageCropModal: React.FC<Props> = ({
  functionSubmit,
  isSubmitContinue = false,
}) => {
  const [imgData, setImgData] = useState('')

  return (
    <div className='modal fade' id='kt_modal_imageCrop' aria-hidden='true'>
      <div className='modal-dialog modal-l'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Select an Image')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div id='kt_modal_imageCrop_Close' className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-body'>
            <div>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >
                <ReactCropper setData={setImgData}></ReactCropper>
              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='button'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  disabled={isSubmitContinue}
                  onClick={(e) => {functionSubmit(imgData)}}
                >
                  <span className='indicator-label'>{LanguageHelp('Save')}</span>
                  {(isSubmitContinue) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ImageCropModal }
